<template>
  <div class="main">
    <!-- banner -->
    <div class="ban" style="background-image: url('/images/ban1.jpg');"></div>
    <!-- banner-end -->
    <!-- 内容 -->
    <div class="wp">
      <div class="g-top">
        <div class="tab">
          <ul>
            <li :class="{on: activeTab === 'docs'}"><a href="/resource-center?type=docs" @click.prevent="setActiveTab('docs')">技术文档</a></li>
            <li :class="{on: activeTab === 'specifications'}"><a href="/resource-center?type=specifications" @click.prevent="setActiveTab('specifications')">产品说明</a></li>
            <li :class="{on: activeTab === 'manuals'}"><a href="/resource-center?type=manuals" @click.prevent="setActiveTab('manuals')">产品手册</a></li>
          </ul>
        </div>
        <div class="cur">
          当前位置：
          <a href="/">首页</a> &gt;
          <a href="/resource-center">资源中心</a> &gt;
          <span v-if="activeTab === 'docs'">技术文档</span>
          <span v-if="activeTab === 'specifications'">产品说明</span>
          <span v-if="activeTab === 'manuals'">产品手册</span>
        </div>
      </div>
    </div>
    <div class="wp">
      <ul class="m-list1" v-if="activeTab === 'docs' || activeTab === 'manuals'">
        <li v-for="(item,index) in resList" :key="index">
          <h3 class="tit"><a @click.prevent="downloadFile(item.pictureAlbumImgCn)" :href="item.pictureAlbumImgCn" :download="item.pictureAlbumNameCn" style="background-image: url('/images/i-21.png');">{{ item.pictureAlbumNameCn }}</a></h3>
          <a @click.prevent="downloadFile(item.pictureAlbumImgCn)" :href="item.pictureAlbumImgCn" :download="item.pictureAlbumNameCn" class="btn">下载</a>
        </li>
      </ul>
      <ul class="m-list2" v-if="activeTab === 'specifications'">
        <li v-for="(item,index) in resList" :key="index">
          <div class="con">
            <h3 class="tit"><a @click.prevent="downloadFile(item.pictureAlbumImgCn)" :href="item.pictureAlbumImgCn" :download="item.pictureAlbumNameCn" >{{ item.pictureAlbumNameCn }}</a></h3>
            <a @click.prevent="downloadFile(item.pictureAlbumImgCn)" :href="item.pictureAlbumImgCn" :download="item.pictureAlbumNameCn" class="btn">下载</a>
          </div>
        </li>

      </ul>
      <!-- <ul class="m-list1" v-if="activeTab === 'manuals'">
        <li>
          <h3 class="tit"><a href="/manuals/manual-1.pdf" download="产品手册1" style="background-image: url('/images/i-21.png');">产品手册标题示例</a></h3>
          <a href="/manuals/manual-1.pdf" download="产品手册1" class="btn">下载</a>
        </li>
        <li>
          <h3 class="tit"><a href="/manuals/manual-2.pdf" download="产品手册2" style="background-image: url('/images/i-21.png');">产品手册标题示例</a></h3>
          <a href="/manuals/manual-2.pdf" download="产品手册2" class="btn">下载</a>
        </li>
        <li>
          <h3 class="tit"><a href="/manuals/manual-3.pdf" download="产品手册3" style="background-image: url('/images/i-21.png');">产品手册标题示例</a></h3>
          <a href="/manuals/manual-3.pdf" download="产品手册3" class="btn">下载</a>
        </li>
        <li>
          <h3 class="tit"><a href="/manuals/manual-4.pdf" download="产品手册4" style="background-image: url('/images/i-21.png');">产品手册标题示例</a></h3>
          <a href="/manuals/manual-4.pdf" download="产品手册4" class="btn">下载</a>
        </li>
      </ul> -->
      <div class="pages">
        <ul>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import RequestUtil from '../utils/request';
export default {
  name: 'ResourceCenter',
  data() {
    return {
      activeTab: 'docs', // 默认显示技术文档
      resList: []
    }
  },
  methods: {
        downloadFile(url) {
      // 在新窗口中打开文件以允许预览，特别是对于PDF文件
      url = "https://program.api.beijingxibao.com" + url;
        window.open(url, '_blank', 'noopener,noreferrer');
    },
    getResList() {
      RequestUtil.get('/wx/picture_album/getPicList?type=' + this.activeTab).then(res => {
        this.resList = res.data;
      });
    },
    setActiveTab(tab) {
      if(tab){
        this.activeTab = tab;
        this.getResList();
      }
      
    },
    updateActiveTabFromRoute(route) {
      const hash = route.hash; // 或者使用 route.
      // alert(hash)
      this.setActiveTab(hash.replace('#', ''));
      // alert(hash)
      this.getResList();
    
    },
  },
    mounted() {
    // 从URL哈希获取当前标签
    this.updateActiveTabFromRoute(this.$route);
    this.$watch(
      () => this.$route,
      (to, from) => {
        this.updateActiveTabFromRoute(to);
      }
    );
  },
  // created() {
  //   // 从查询参数获取当前类型
  //   const type = this.$route;
  //   alert(type);
  //   if (type && ['docs', 'specifications', 'manuals'].includes(type)) {
  //     this.setActiveTab(type);
  //   }
  // },
 
}
</script>

<style scoped>


 @media only screen and (max-width: 1199px) {
    .ban ,.g-top {
      display: block !important;
     
    }
    .g-top{
       margin-top: -5vw;
       box-shadow: 0px 2px 21px 0px rgba(0,24,52,0.07);
       background: #FFFFFF;
       height: 44px;
       line-height: 44px;
       
      
    }
    .g-top .tab li a{
      font-size: 12px !important;
    }
}
</style>